import { FunctionComponent } from "react";
import Checkbox from "./Checkbox";

interface ITableCheckboxProps {
    data: string;
    checked: boolean;
    toggleSelected: (checked: boolean, data: string) => void;
}

const TableCheckbox: FunctionComponent<ITableCheckboxProps> = ({ data, checked, toggleSelected }) => (
    <Checkbox
        labelText=""
        checked={checked}
        onChange={(event) => toggleSelected(event.target.checked, data)}
    />
);

export default TableCheckbox;